import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'default' | 'large';
}

export default function ComicCard({ comic, size = 'default' }: ComicCardProps) {
  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block"
    >
      {/* Cover */}
      <div
        className={`relative overflow-hidden rounded-lg mb-3 ${
          size === 'large' ? 'aspect-[3/4]' : 'aspect-[2/3]'
        }`}
      >
        <img
          src={comic.cover}
          alt={comic.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <span className="text-white text-xs font-medium bg-primary-500/90 px-2 py-1 rounded whitespace-nowrap">
            立即阅读
          </span>
        </div>
        {/* Status Badge */}
        <div className="absolute top-2 left-2">
          <span
            className={`text-[10px] font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${
              comic.status === '连载中'
                ? 'bg-primary-500 text-white'
                : 'bg-foreground-600 text-background-50'
            }`}
          >
            {comic.status}
          </span>
        </div>
        {/* Rating Badge */}
        <div className="absolute top-2 right-2 flex items-center gap-0.5 bg-black/60 text-white text-[10px] font-medium px-1.5 py-0.5 rounded-full">
          <i className="ri-star-fill text-accent-400 text-[10px]"></i>
          {comic.rating}
        </div>
      </div>

      {/* Info */}
      <div>
        <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1 mb-1">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 line-clamp-1 mb-1.5">
          {comic.author}
        </p>
        <p className="text-[11px] text-foreground-400">
          {comic.latestChapter}
        </p>
      </div>
    </Link>
  );
}